// local.js — the localStorage mirror. The app keeps a full copy of its state in
// the browser so it opens instantly and survives offline moments.

import { S, activeRecord, ensureIds } from './state.js';

export function saveToLocal() {
  localStorage.setItem('fishbowlTasks', JSON.stringify(S.tasks));
  localStorage.setItem('fishbowlDone', JSON.stringify(S.completed));
  localStorage.setItem('fishTags', JSON.stringify(S.tags));
  localStorage.setItem('manualQueue', JSON.stringify(S.manualQueue));
  localStorage.setItem('fishbowlDeleted', JSON.stringify(S.deletedIds));
}

// Read the mirror into state (used once at startup, before the cloud loads).
export function loadLocal() {
  const parse = (k, fallback) => { try { return JSON.parse(localStorage.getItem(k) || 'null') ?? fallback; } catch (e) { return fallback; } };
  S.deletedIds = parse('fishbowlDeleted', []) || [];
  S.manualQueue = ensureIds(parse('manualQueue', []), true);
  S.tasks = ensureIds(parse('fishbowlTasks', []), true);
  S.completed = ensureIds(parse('fishbowlDone', []), true);
  S.tags = parse('fishTags', []) || [];
}

// The active task is written to localStorage immediately so a refresh
// (or a mobile browser evicting the tab) never loses the task or its timer.
export function persistActive() {
  localStorage.setItem('fishbowlActive', JSON.stringify(activeRecord()));
}

export function readActive() {
  try { return JSON.parse(localStorage.getItem('fishbowlActive') || 'null'); } catch (e) { return null; }
}

export function loadStreakLocal() {
  S.lastCatchDate = localStorage.getItem('lastCatchDate') || '';
  S.streak = parseInt(localStorage.getItem('streak') || '0', 10) || 0;
}

export function saveStreakLocal() {
  localStorage.setItem('lastCatchDate', S.lastCatchDate);
  localStorage.setItem('streak', String(S.streak));
}

export function saveTags() {
  localStorage.setItem('fishTags', JSON.stringify(S.tags));
}
